/**
 * Shared formatters for pre-approval display values.
 * Used by VisualTemplatePreview, PDF generator, SendModal, and BorrowerPortal.
 */

export function formatLoanType(type: string): string {
  const map: Record<string, string> = {
    conventional: 'Conventional',
    fha: 'FHA',
    va: 'VA',
    usda: 'USDA',
    jumbo: 'Jumbo'
  };
  return map[type?.toLowerCase()] || type;
}

export function formatPropertyType(type: string): string {
  const map: Record<string, string> = {
    'single-family': 'Single Family',
    condo: 'Condominium',
    townhouse: 'Townhouse',
    'multi-family': 'Multi-Family'
  };
  return map[type] || type;
}

export function formatOccupancy(occupancy: string): string {
  const map: Record<string, string> = {
    primary: 'Primary Residence',
    secondary: 'Secondary Home',
    investment: 'Investment Property'
  };
  return map[occupancy] || occupancy;
}
